import React from 'react'
import { ProductWrapper } from './ProductStyled';

function Product() {
    return (
        <ProductWrapper >
            <div className="container-card">
                <div className="card-sales">
                    <div className="laptop-card">
                        <span className="hot-sale">Hot</span>
                        <div>
                            <img src="img/lp.c11683f6.png" alt="item_object" />
                            <h3>Apple Macbook Pro</h3>
                        </div>
                        <div className="star-rating">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        <p><span className="actual-price">$499</span> <span class="price-tag">$599</span></p>
                    </div>
                    <div className="laptop-card">
                        <span className="hot-sale">Hot</span>
                        <div>
                            <img src="img/lp.c11683f6.png" alt="item_object" />
                            <h3>Apple Macbook Pro</h3>
                        </div>
                        <div className="star-rating">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        <p><span className="actual-price">$499</span> <span class="price-tag">$599</span></p>
                    </div>
                    <div className="laptop-card">
                        <span className="hot-sale">Hot</span>
                        <div>
                            <img src="img/lp.c11683f6.png" alt="item_object" />
                            <h3>Apple Macbook Pro</h3>
                        </div>
                        <div className="star-rating">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        <p><span className="actual-price">$499</span> <span class="price-tag">$599</span></p>
                    </div>
                    <div className="laptop-card">
                        <span className="hot-sale">Hot</span>
                        <div>
                            <img src="img/lp.c11683f6.png" alt="item_object" />
                            <h3>Apple Macbook Pro</h3>
                        </div>
                        <div className="star-rating">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        <p><span className="actual-price">$499</span> <span class="price-tag">$599</span></p>
                    </div>
                    <div className="laptop-card">
                        <span className="hot-sale">Hot</span>
                        <div>
                            <img src="img/lp.c11683f6.png" alt="item_object" />
                            <h3>Apple Macbook Pro</h3>
                        </div>
                        <div className="star-rating">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        <p><span className="actual-price">$499</span> <span class="price-tag">$599</span></p>
                    </div>
                    <div className="laptop-card">
                        <span className="hot-sale">Hot</span>
                        <div>
                            <img src="img/lp.c11683f6.png" alt="item_object" /> 
                            <h3>Apple Macbook Pro</h3>
                        </div>
                        <div className="star-rating">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </div>
                        <p><span className="actual-price">$499</span> <span class="price-tag">$599</span></p>
                    </div>
                </div>
            </div>
        </ProductWrapper>
    )
}

export default Product